export const ASK_NEEDL_NOT_ENABLED = [
  'bookmarks',
  'clipped_reports',
  'tags',
  'comments',
  'assistants',
  'app',
];
